import { render, staticRenderFns } from "./DTEventForAR.vue?vue&type=template&id=36006d78&scoped=true"
import script from "./DTEventForAR.vue?vue&type=script&lang=js"
export * from "./DTEventForAR.vue?vue&type=script&lang=js"
import style0 from "./DTEventForAR.vue?vue&type=style&index=0&id=36006d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36006d78",
  null
  
)

export default component.exports